import { render, staticRenderFns } from "./DataNavagations.vue?vue&type=template&id=f1018874&"
import script from "./DataNavagations.vue?vue&type=script&lang=js&"
export * from "./DataNavagations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports